<script lang="ts">
	//Helpers
	import { get_local_ip, real_id } from '../../../../../helpers/interface_helpers';
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Services
	import { localReq, postReq } from '../../../../../services/http';
	import { format } from '../../../../../services/i18n';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Button, Checkbox, Radio, Text, toast } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	let settings = readDeviceSettings(id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore ?? settings;

	const btn_types = ['momentary', 'toggle', 'edge', 'detached', 'action'];
	const options = [
		$format('option_momentary', {
			default:
				' Momentary - Set Shelly device to be "Momentary" switch. Push-for "ON" or Push-for "OFF".',
		}),
		$format('option_toggle_switch', {
			default:
				'Toggle Switch - Set Shelly device to be "Toggle" switch. Act as a flip switch with one state for "ON" and one state for "OFF".',
		}),
		$format('option_edge_switch', {
			default: 'Edge Switch - Set Shelly device to be "Edge" switch. Changes state on every hit.',
		}),
		$format('btn_mode_detached_description', {
			default:
				'Detached Switch - Set Shelly device to be in "Detached" switch mode - switch is separated from the relays.',
		}),
		$format('option_activation_switch', {
			default:
				'Activation Switch - use it for motion sensor. Any input turns "ON" and resets Auto OFF timer.',
		}),
	];

	let reverse = settings[device.category + 's'][0].btn_reverse;
	let cacheReverse = reverse;
	let index = btn_types.indexOf(settings[device.category + 's'][0].btn_type);
	let cacheIndex = index;

	let loading = false;

	let localIp = get_local_ip(id);

	const toggleReverse = async () => {
		reverse = !reverse;
	};

	const setType = (val) => {
		index = val;
	};

	const sentRequests = async () => {
		let setBtnType; //prepare variable for first promise
		let handleToggle; //prepare variable for second promise
		if (cacheIndex !== index) {
			loading = true;
			if (localIp) {
				setBtnType = await localReq(device, `${localIp}/settings/${settings.mode}/0`, 'post', {
					btn_type: btn_types[index],
				});
			} else {
				setBtnType = await postReq(`/device/${device.category}/settings/button_type`, {
					id: id,
					channel: 0,
					type: btn_types[index],
				});
			}
		}
		if (cacheReverse !== reverse) {
			loading = true;
			if (localIp) {
				handleToggle = await localReq(
					device,
					`${localIp}/settings/${settings.mode}/${device.channel}`,
					'post',
					{
						btn_reverse: reverse ? 1 : 0,
					},
				);
			} else {
				handleToggle = await postReq(`/device/${device.category}/settings/btn_reverse`, {
					id: id,
					channel: device.channel,
					btn_reverse: reverse ? 1 : 0,
				});
			}
		}
		Promise.all([setBtnType, handleToggle]).then((res) => {
			if (typeof res[0] !== 'undefined') {
				if (res[0].isok) {
					settings[device.category + 's'][0].btn_type = btn_types[index];
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title:
							$format('btn_type_scc_toast', {
								values: {
									type_value: formatSnakeCaseToTitle(btn_types[index]),
								},
							}) ||
							`Button type was changed to ${formatSnakeCaseToTitle(btn_types[index])}.`,
					});
					cacheIndex = index;
				} else {
					index = cacheIndex;
					toast.open({ type: 'danger', title: $format('error_global') });
				}
			}
			if (typeof res[1] !== 'undefined') {
				if (res[1].isok) {
					settings[device.category + 's'][0].btn_reverse = reverse;
					devices_settings.update_devices_settings(id, settings);
					toast.open({
						type: 'success',
						title: $format('swap_inputs_scc_toast') || `Inputs was reversed.`,
					});
					cacheReverse = reverse;
				} else {
					toast.open({ type: 'danger', title: $format('error_global') });
					reverse = cacheReverse;
				}
			}
			loading = false;
		});
	};
</script>

{#each btn_types as _type, i}
	<Radio
		size="m"
		selected={index.toString()}
		value={i.toString()}
		on:click={() => setType(i)}
		id="radio-qoxnrdy">{options[i]}</Radio
	>
{/each}

<Checkbox size="m" checked={reverse} on:click={toggleReverse} id="checkbox-m5g825s"
	>{$format('option_reverse_inputs', {
		default:
			'Reverse inputs - If you enable this option, the buttons On/Off position will be inverted.',
	})}</Checkbox
>
<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequests}
	>{$format('button_save')}</Button
>
